import { Typography } from "@mui/material";
import { useQuery } from "@tanstack/react-query";
import { useFormikContext } from "formik";
import { type FC } from "react";
import { type ChargebackWorkPacket } from "src/types/work-packets";
import { getChargebackRemittances } from "../../../queries/work-packets";
import { WorkPacketType } from "../../../WorkPacketType";
import { FormFieldsGroup } from "../components";
import { ReadOnlyTextField } from "src/components/UI/Form/ReadOnlyTextField";

export const ChargebackRemittances: FC = () => {
  const { values: packet } = useFormikContext<ChargebackWorkPacket>();
  const query = useQuery({
    queryKey: ["work-packets", WorkPacketType.CHARGEBACKS, "remittance", packet.packetId],
    queryFn: getChargebackRemittances,
    staleTime: 30000,
  });

  if (query.isPending) {
    return <Typography paddingTop={3}>Loading remittance data...</Typography>;
  }

  if (query.isError) {
    return <Typography paddingTop={3}>Failed to load remittance data</Typography>;
  }

  return (
    <>
      {query.data.map((remittance, index) => {
        const remittanceNumber = index + 1;
        const id = `remittance-${index}`;

        return (
          <FormFieldsGroup withDivider title={`Payment Details ${remittanceNumber}`} id={id} key={id}>
            <ReadOnlyTextField label="Payment Status" value={remittance.paymentStatus} />
            <ReadOnlyTextField label="Stage" value={remittance.stage} />
            <ReadOnlyTextField label="Remittance Invoice ID" value={remittance.remittanceInvoiceId} />
            <ReadOnlyTextField label="Payment ID" value={remittance.paymentId} />
            <ReadOnlyTextField label="Payment Amount" value={remittance.paymentAmount} />
            <ReadOnlyTextField label="Payment Date" value={remittance.paymentDate} />
            <ReadOnlyTextField label="C6 Invoices Client Amount" value={remittance.c6InvoicesClientAmount} />
            <ReadOnlyTextField label="C6 Invoiced Date" value={remittance.c6InvoicedDate} />
          </FormFieldsGroup>
        );
      })}
    </>
  );
};
